import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class ThresholdEvaluationTypesService {

  static getAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}thresholdevaluationtypes`).then((data) => {
        resolve({ thresholdEvaluationTypes: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default ThresholdEvaluationTypesService;
